const defaultState = {
    authStatus: 'appLoading',
    action: 'welcome',
    newCat: {
        id: 0,
        name: '',
        description: '',
        },
    updCat: {
        id: 0,
        name: '',
        description: '',
    },
    newProd: {
        id: 0,
        name: '',
        description: '',
        price: 1,
        categoryId: 0,
        categoryName: "",
    },
    picsInDB: [],
    picsToDelete: [],
    newPics: [],
    updProd: {
        id: 0,
        name: '',
        description: '',
        price: 1,
        categoryId: 0,
        categoryName: "",
    },
    notifyList: [],
    freeze: false,
}

// Редюсер - чистая функция. Принимает состояние и экшн. Возвращает новое состояние.
export const rootReducer = (state = defaultState, action) => {
    switch (action.type) {
        // // сохранение id для нового (добавляемого) товара и categoryId (если передан)
        // case 'SetNewCatId':
        //     return { ...state,
        //         newCat: {
        //             id: Number(action.id),
        //             name: state.newCat.name,
        //             description: state.newCat.description,
        //             }
        //         }
        // // нажата кнопка "Создать категорию"
        // case 'SetActionAddCat':
        //     return { ...state,
        //         action: 'addC'
        //         }
        case 'SetAuthStatus':
            return { ...state,
                authStatus: action.authStatus
            }

        case 'ResetupNewCat':
            return { ...state,
                newCat: {
                    id: state.newCat.id + 1,
                    name: '',
                    description: '',
                    }
                }
        // Нажата кнопка "Создать категорию"
        case 'SetNewCat':
            return { ...state,
                action: 'addC',
                newCat: {
                    id: Number(action.id),
                    name: state.newCat.name,
                    description: state.newCat.description,
                    }
                }
        // Текущее поле name 
        case 'SetNewCatTitle':
            return { ...state, 
                newCat: {
                    id: state.newCat.id,
                    name: action.name,
                    description: state.newCat.description,
                },
            }
        // Текущее поле description 
        case 'SetNewCatDescr':
            return { ...state, 
                newCat: {
                    id: state.newCat.id,
                    name: state.newCat.name,
                    description: action.description,
                },
            }



        // Повторный клик на категории
        case 'SetActionUpdCAgain':
            return { ...state,
                action: 'updC',
                // снимаем выделение с товара
                updProd: {
                    id: 0,
                    name: "",
                    description: "",
                    price: 1,
                    categoryId: 0,
                    categoryName: "",
                }
            }

        case 'SetUpdCatId':
            return { ...state,
                updCat: {
                    id: action.id,
                    name: state.updCat.name,
                    description: state.updCat.description,
                }
            }
        // Смена категории
        case 'SetUpdCategory':
            return { ...state,
                action: 'updC',// обновление категории
                updCat: {
                    // id: Number(action.id),
                    id: action.id,
                    name: action.name,
                    description: action.description,
                },
                // Очистка upd товара при смене категории:
                updProd: {
                    id: 0,
                    name: "",
                    description: "",
                    price: 1,
                    categoryId: 0,
                    categoryName: "",
                }
            }
        // Текущее поле name (категории)
        case 'SetTypedCName':
            return { ...state, 
                updCat: {
                    id: state.updCat.id,
                    name: action.name,
                    description: state.updCat.description,
                },
            }
        // Текущее поле description (категории)
        case 'SetTypedCDescr':
            return { ...state, 
                updCat: {
                    id: state.updCat.id,
                    name: state.updCat.name,
                    description: action.description,
                },
            }





        case 'ResetupNewProd':
            return { ...state,
                newProd: {
                    // id: state.newProd.id + 1,
                    id: state.newProd.id + 1,
                    name: '',
                    description: '',
                    price: 1,
                    categoryId: state.newProd.categoryId,
                    categoryName: state.newProd.categoryName,
                    }
                }
        // Нажата кнопка "Добавить товар"
        case 'SetNewProd':
            // сохраняем id для нового (добавляемого) товара и categoryId (если передан)
            let categoryId
            let categoryName
                if(action.categoryId) {
                    categoryId = action.categoryId
                    categoryName = action.categoryName
                } else {
                    categoryId = state.newProd.categoryId
                    categoryName = state.newProd.categoryName
                }
                    // console.log('reducer - categoryId: ', categoryId);
            return { ...state,
                action: 'addP',
                newProd: {
                    id: Number(action.id),
                    name: state.newProd.name,
                    description: state.newProd.description,
                    price: state.newProd.price,
                    categoryId: Number(categoryId),
                    categoryName: categoryName,
                    }
                }
        // Текущее поле name 
        case 'SetNewProdTitle':
            return { ...state, 
                newProd: {
                    id: state.newProd.id,
                    name: action.name,
                    description: state.newProd.description,
                    price: state.newProd.price,
                    categoryId: state.newProd.categoryId,
                    categoryName: state.newProd.categoryName,
                },
            }
        // Текущее поле description 
        case 'SetNewProdDescr':
            return { ...state, 
                newProd: {
                    id: state.newProd.id,
                    name: state.newProd.name,
                    description: action.description,
                    price: state.newProd.price,
                    categoryId: state.newProd.categoryId,
                    categoryName: state.newProd.categoryName,
                },
            }
        // Текущее поле price 
        case 'SetNewProdPrice':
            return { ...state, 
                newProd: {
                    id: state.newProd.id,
                    name: state.newProd.name,
                    description: state.newProd.description,
                    price: action.price,
                    categoryId: state.newProd.categoryId,
                    categoryName: state.newProd.categoryName,
                },
            }



        case 'SetUpdProd':
            return { ...state,
                action: 'updP',
                updProd: {
                    // id: Number(action.id),
                    id: action.id,
                    name: action.name,
                    description: action.description,
                    price: action.price,
                    categoryId: state.updCat.id,
                    categoryName: state.updCat.name,
                }
            }
        case 'ClearUpdProd':
            return { ...state,
                updProd: {
                    id: 0,
                    name: "",
                    description: "",
                    price: 1,
                    categoryId: 0,
                    categoryName: "",
                }
            }
        // Текущее поле name (товара)
        case 'SetTypedPName':
            return { ...state, 
                updProd: {
                    id: state.updProd.id,
                    name: action.name,
                    description: state.updProd.description,
                    price: state.updProd.price,
                    categoryId: state.updProd.categoryId,
                    categoryName: state.updProd.categoryName,
                },
            }
        // Текущее поле description (товара)
        case 'SetTypedPDescr':
            return { ...state, 
                updProd: {
                    id: state.updProd.id,
                    name: state.updProd.name,
                    description: action.description,
                    price: state.updProd.price,
                    categoryId: state.updProd.categoryId,
                    categoryName: state.updProd.categoryName,
                },
            }
        // Текущее поле description (товара)
        case 'SetTypedPPrice':
            return { ...state, 
                updProd: {
                    id: state.updProd.id,
                    name: state.updProd.name,
                    description: state.updProd.description,
                    price: action.price,
                    categoryId: state.updProd.categoryId,
                    categoryName: state.updProd.categoryName,
                },
            }


        //  После удаления категории или товара
        case 'SetActionDefault':
            return { ...state,
                action: ''
                }
        // Заморозка
        case 'SetFreeze':
            return { ...state,
                freeze: action.value
                }
        // Сохранение списка изображений
        case 'SetPicsInDB':
            return { ...state,
                picsInDB: action.picsInDB
                }
        // Обновление списка изображений
        case 'UpdatePicsInDB':
            return { ...state,
                picsInDB: action.picsInDB
                }
        // Возврат элементов из picsToDelete в стор picsInDB
        case 'AddToPicsInDB':
            return { ...state,
                picsInDB: [...state.picsInDB, ...action.picsInDB]
                }
        // Добавление изображений в массив
        case 'AddPicsToDelete':
            return { ...state,
                picsToDelete: [...state.picsToDelete, action.picsToDelete]
                }
        // Очистка списка изображений
        case 'ClearPicsToDelete':
            return { ...state,
                picsToDelete: []
                }

        // Добавление изображений в массив
        case 'AddNewPics':
            return { ...state,
                // newPics: [...state.newPics, ...action.newPics]
                newPics: [...state.newPics, action.newPics]
                }
        // Обновление списка изображений (после функции deleteFiles)
        case 'SetNewProdPics':
            return { ...state,
                newPics: action.newPics
                }
        // Очистка списка изображений
        case 'ClearNewPics':
            return { ...state,
                newPics: []
                }

        // Добавление уведомления
        case 'AddNotify':
            return { ...state,
                notifyList: [ action.newNotify, ...state.notifyList ]
                }

        // // Обновление списка уведомлений
        // case 'UpdateNotifyList':
        //     return { ...state,
        //         notifyList: action.notifyList
        //         }
        // Обновление списка уведомлений
        case 'DeleteFromNotifyList':
            return { ...state,
                notifyList: state.notifyList.filter(item => item.id !== action.id)
                }

        default:
            return state
    }  
}